import {
  Body,
  Button,
  Heading,
  IconButton,
  Tooltip,
} from '@assembly-js/design-system';
import React, { useContext } from 'react';

import { ToolbarDivider } from 'src/components/ToolbarDivider';
import { ContractBuilderContext } from 'src/context/contractBuilderContext';
import { FormPageHeaderProps } from 'src/legacy/components/Page/formPageTypes';

interface ContractBuilderModalHeaderProps extends FormPageHeaderProps {
  onCancel: () => void;
  handleSubmit: () => void;
}

export const ContractBuilderModalHeader: React.FC<
  ContractBuilderModalHeaderProps
> = ({
  onCancel,
  handleSubmit,
  isSubmitting = false,
  isDisabled,
  tooltipComponent,
}) => {
  const { isOneOffContract } = useContext(ContractBuilderContext);

  const label = isOneOffContract ? 'Send' : 'Create template';

  return (
    <div className="sticky top-0 z-10 flex items-center justify-between border-b border-solid border-x-0 border-t-0 border-non-hover-border bg-white px-4 sm:px-6 py-4 h-15">
      <div className="flex shrink-0 items-center gap-2 sm:gap-3 overflow-hidden pr-4">
        <IconButton
          icon="Close"
          onClick={onCancel}
          label="Close"
          variant="minimal"
          className="text-black-heading"
          size="sm"
        />
        <ToolbarDivider />
        <Heading className="text-sm sm:text-lg text-black-heading">
          Create contract
        </Heading>
      </div>

      <div className="flex items-center gap-2.5">
        <Button
          label="Cancel"
          variant="secondary"
          onClick={onCancel}
          size="sm"
        />
        <Tooltip
          content={
            tooltipComponent ? (
              <Body size="sm" className="max-w-[288px]">
                {tooltipComponent}
              </Body>
            ) : (
              ''
            )
          }
          position="bottom"
        >
          <span>
            <Button
              label={label}
              variant="primary"
              onClick={handleSubmit}
              loading={isSubmitting}
              disabled={isDisabled}
              size="sm"
              type="submit"
            />
          </span>
        </Tooltip>
      </div>
    </div>
  );
};
